(() => {
  'use strict';

  if (customElements.get('look-component')) return;

  customElements.define(
    'look-component',
    class LookComponent extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('[data-slider-mobile]');
        this.slides = this.querySelectorAll('[data-slide]');
        this.thumbs = this.querySelectorAll('[data-slider-thumb]');
        this.popupContainer = this.querySelector('[data-popup-container]');
        this.popupClose = this.querySelectorAll('[data-popup-close]');
        this.popupCloseByEvent = this.popupCloseByEvent.bind(this);
        this.gridSlider = this.querySelector('grid-slider');
      }

      connectedCallback() {
        if (!this.slider || !this.slides.length || !this.thumbs.length) return;

        this.bindPopupEvents();
        this.bindThumbEvents();
      }

      bindPopupEvents() {
        if (!this.popupContainer) return;

        this.popupContainer.addEventListener('transitionend', (event) => {
          if (event.target !== this.popupContainer) return;

          this.popupContainer.classList.remove('is-animating');

          if (event.target.classList.contains('is-open')) {
            this.popupOpenCallback();
            return;
          }

          this.popupCloseCallback();
        });

        this.popupContainer.addEventListener('transitionstart', (event) => {
          if (event.target === this.popupContainer) {
            this.popupContainer.classList.add('is-animating');
          }
        });

        this.popupClose.forEach((closeButton) => {
          closeButton.addEventListener('click', () => {
            this.popupContainer.classList.remove('is-open');
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
          });
        });
      }

      bindThumbEvents() {
        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleThumbClick(thumb, index);
          });
        });
      }

      handleThumbClick(thumb, index) {
        const slideIndex = thumb.hasAttribute('data-slider-thumb') && thumb.getAttribute('data-slider-thumb') !== ''
          ? parseInt(thumb.getAttribute('data-slider-thumb'))
          : index;
        const slide = this.slides[slideIndex];

        if (!slide) return;

        if (theme.isMobile) {
          const sliderPadding = parseInt(window.getComputedStyle(this.slider).paddingLeft) || 0;

          this.slider.scrollTo({
            top: 0,
            left: slide.offsetLeft - sliderPadding,
            behavior: 'auto',
          });

          if (this.hasAttribute('data-inline-mobile')) {
            this.scrollToInlineProducts();
            return;
          }

          document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
          this.popupContainer?.classList.add('is-animating', 'is-open');
        }

        if (this.gridSlider && this.gridSlider.isInitialized) {
          this.gridSlider.goToSlide(slide);
          return;
        }

        this.scrollToSlide(slide);
      }

      scrollToInlineProducts() {
        const heights = window.theme.readHeights ? window.theme.readHeights() : {};
        const stickyHeaderHeight = heights.stickyHeaderHeight || 0;
        const top = this.slider.getBoundingClientRect().top + window.scrollY - stickyHeaderHeight - 16;

        this.popupContainer?.classList.remove('is-open', 'is-animating');
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

        window.scrollTo({
          top: Math.max(top, 0),
          left: 0,
          behavior: 'smooth',
        });
      }

      scrollToSlide(slide) {
        const {stickyHeaderHeight} = window.theme.readHeights();
        const slideTop = slide.getBoundingClientRect().top;
        const slideHalfHeight = slide.offsetHeight / 2;
        const viewportHeight = window.innerHeight;
        const lookTop = this.getBoundingClientRect().top + window.scrollY;
        const lookBottom = lookTop + this.offsetHeight;
        let scrollTarget = slideTop + slideHalfHeight - viewportHeight / 2 + window.scrollY;

        if (scrollTarget < lookTop) {
          scrollTarget = lookTop - stickyHeaderHeight;
        } else if (scrollTarget + viewportHeight > lookBottom) {
          scrollTarget = lookBottom - viewportHeight;
        }

        window.scrollTo({
          top: scrollTarget,
          left: 0,
          behavior: 'smooth',
        });
      }

      popupCloseByEvent() {
        this.popupContainer?.classList.remove('is-open');
      }

      popupOpenCallback() {
        document.addEventListener('theme:quick-add:open', this.popupCloseByEvent, {once: true});
        document.addEventListener('theme:product:added', this.popupCloseByEvent, {once: true});
      }

      popupCloseCallback() {
        document.removeEventListener('theme:quick-add:open', this.popupCloseByEvent);
        document.removeEventListener('theme:product:added', this.popupCloseByEvent);
      }
    }
  );
})();
